(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-tiles"] && !Shopify.designMode) return;
  try {
    
  /* Register multicolumn-scrollbar if not already defined by multicolumn.liquid */
  if (!customElements.get('multicolumn-scrollbar')) {
    class MulticolumnScrollbar extends HTMLElement {
      connectedCallback() {
        this._scroller = this.closest('.shopify-section')?.querySelector('.multicolumn-scroll-row');
        this._track = this.querySelector('.multicolumn-scrollbar__track');
        this._thumb = this.querySelector('.multicolumn-scrollbar__thumb');
        if (!this._scroller || !this._thumb) return;

        this._onScroll = () => this._update();
        this._onResize = () => this._update();
        this._scroller.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });
        this._update();
      }

      disconnectedCallback() {
        this._scroller?.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
      }

      _update() {
        const { scrollLeft, scrollWidth, clientWidth } = this._scroller;
        if (scrollWidth <= clientWidth) return;
        const trackWidth = this._track.offsetWidth;
        const thumbWidth = Math.max(32, trackWidth * (clientWidth / scrollWidth));
        const maxLeft = trackWidth - thumbWidth;
        const progress = scrollLeft / (scrollWidth - clientWidth);
        this._thumb.style.width = thumbWidth + 'px';
        this._thumb.style.transform = `translateX(${progress * maxLeft}px)`;
      }
    }

    customElements.define('multicolumn-scrollbar', MulticolumnScrollbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  class MulticolumnScrollbar extends HTMLElement {
    connectedCallback() {
      this._scroller = this.closest('.shopify-section')?.querySelector('.multicolumn-scroll-row');
      this._track = this.querySelector('.multicolumn-scrollbar__track');
      this._thumb = this.querySelector('.multicolumn-scrollbar__thumb');
      if (!this._scroller || !this._thumb) return;

      this._onScroll = () => this._update();
      this._onResize = () => this._update();
      this._scroller.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      this._scroller?.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    _update() {
      const { scrollLeft, scrollWidth, clientWidth } = this._scroller;
      if (scrollWidth <= clientWidth) return;
      const trackWidth = this._track.offsetWidth;
      const thumbWidth = Math.max(32, trackWidth * (clientWidth / scrollWidth));
      const maxLeft = trackWidth - thumbWidth;
      const progress = scrollLeft / (scrollWidth - clientWidth);
      this._thumb.style.width = thumbWidth + 'px';
      this._thumb.style.transform = `translateX(${progress * maxLeft}px)`;
    }
  }

  if (!customElements.get('multicolumn-scrollbar')) {
    customElements.define('multicolumn-scrollbar', MulticolumnScrollbar);
  }

  } catch(e) { console.error(e); }
})();
})();
